import { PropsWithChildren, useEffect, useState } from 'react';
import { playbackRegistry } from '../registry/playback-registry';
import { PlaybackStoreApi, PlaybackStoreContext } from './playback.context';

export type Props = PropsWithChildren<{
  store?: PlaybackStoreApi;
}>;

/**
 * Provider that creates and manages a playback store instance.
 * Requires a pre-created store to be passed via the 'store' prop.
 * Use VideoPlaybackProvider, SegmentsAudioPlaybackProvider, or LiveUrlAudioPlaybackProvider instead.
 */

export function PlaybackProvider({ store: initialStore, children }: Props) {
  const [store, setStore] = useState<PlaybackStoreApi | undefined>(initialStore);

  useEffect(() => {
    if (!store) {
      return;
    }

    const unregister = playbackRegistry.register(store);

    return () => {
      unregister();
      store?.getState().dispose();
    };
  }, [store]);

  return (
    <PlaybackStoreContext.Provider value={{ store, setStore }}>
      {children}
    </PlaybackStoreContext.Provider>
  );
}
